import { render } from "./AkanezoranoPlanetariumTalentList.vue?vue&type=template&id=2f74cafa&scoped=true&ts=true&lang=pug"
import script from "./AkanezoranoPlanetariumTalentList.vue?vue&type=script&lang=ts"
export * from "./AkanezoranoPlanetariumTalentList.vue?vue&type=script&lang=ts"

import "./AkanezoranoPlanetariumTalentList.vue?vue&type=style&index=0&id=2f74cafa&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f74cafa"]])

export default __exports__